// Simple row layout
import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import { type RestQuote } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';

type Props = {
  info: RestQuote;
  class?: string;
};
const ModalQuote: React.FC<Props> = (props) => {
  const { info: quote, class: className } = props;

  return (
    <div className={cs('modal-quote', className, { quad: className })}>
      <div className="MQContainer">
        <div className="quote-bubble">
          <div className="quote-text">
            <CustomerHtml value={quote.text} />
          </div>
          <div className="arrow-down" />
        </div>
        <div className="quote-person">
          {quote.avatar ? (
            <img src={quote.avatar} alt="" className="quote-img" />
          ) : (
            <span className="quote-avatar">
              <PersonIcon style={{ height: '42px', width: '42px' }} />
            </span>
          )}
          <div className="quote-info">
            <div className="quote-name">{quote.name}</div>
            <div className="quote-position">{quote.title}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalQuote;
